import { MpColumnFormatter } from "../../types/Table";

export const mapFormatter: MpColumnFormatter = ({ value, options }) => {
  return options?.valueMap?.[value] ?? value;
};
